import { siteConfig } from "@/lib/siteConfig";

export function initAnalytics() {
  if (siteConfig.gaId) {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${siteConfig.gaId}`;
    script.async = true;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", siteConfig.gaId);
  }

  if (siteConfig.metaPixelId) {
    window.fbq = window.fbq || function fbq() {
      (window.fbq.q = window.fbq.q || []).push(arguments);
    };
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    script.async = true;
    document.head.appendChild(script);
    window.fbq("init", siteConfig.metaPixelId);
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) window.fbq("trackCustom", name, params);
}
